import { ModelType, SchemaModelFieldType } from '@smx-ui-model/types';
import { Alert, Form, Input } from 'antd';
import * as React from 'react';
import { IdTableCell } from './id-table-cell';

interface EntityWrapperTableCellProps {
    schemaData: SchemaModelFieldType;
    model: ModelType<any>;
    fieldData: any;
    dataEntity: any;
}

export const EntityWrapperTableCell: React.FC<EntityWrapperTableCellProps> = ({ schemaData, dataEntity, model, fieldData }) => {
    const getValueByType = () => {
        const renderFromModel = model.renderData?.tableCell?.[schemaData.name];

        if (renderFromModel) {
            return renderFromModel(schemaData, fieldData, dataEntity);
        }

        if(schemaData.name === 'id'){
            return <IdTableCell value={fieldData} />
        }

        switch (schemaData.type) {
            case 'string':
            case 'integer':
            case '[string]': {
                if(model.context?.tableInput?.includes(schemaData.name)){
                    return <Form.Item name={[dataEntity.id, schemaData.name]} style={{margin: 0}}>
                            <Input />
                        </Form.Item>;
                }
                return fieldData

            }
            default:
                if (Array.isArray(fieldData)) {
                    fieldData?.map((fragment: any) => {
                        const [fragmentName] = Object.keys(fragment.__fragments);
                        console.log('======', schemaData, fragmentName);
                    });
                } else {
                    console.log('##############');
                }

                return <Alert message={`Error field type - ${schemaData.type}`} type="error" showIcon />;
        }
    };

    return getValueByType();
};
